import styled from "styled-components";

export const Container = styled.div`
  /* max-width: 80vw; */
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 50px;
`;
